const Mappings = {
    retirement: "Retirement",
    healthIssues: "Health Issues",
    businessTrendingDown: "Business trending down",
    investElsewhere: "Invest elsewhere",
    broker: "Broker has a buyer",
    relative: "Relative",
    partner: "Business associate/partner",
    bankingServices: "Banking services",
    sellYourBusiness: "Sell Your Business",
    buyABusiness: "Buy A Business",
    loan: "Loan",
    insurance: "Insurance",
    pos: "POS",
    educationMentorship: "Education / Mentorship",
    accountingServices: "Accounting Services",
    marketingServices: "Marketing Services",
    restaurantsFood: "Restaurants & Food",
    manufacturing: "Manufacturing",
    serviceBusiness: "Service Business(Salon, Dental)",
    retailRestaurant: "Retail/Restaurant",
    entertainmentRecreation: "Entertainment & Recreation",
    buildingConstruction: "Building & Construction",
    transportationStorage: "Transportation & Storage",
    airbnb: "Airbnb",
    cCorporation: "C Corporation",
    sCorporation: "S Corporation",
    llc: 'LLC',
    other: "Other",
    home: "Home",
    ourServices: "Our Services",
    sellBusiness: "Sell Business",
    brokerFinder: "Broker Finder",
    financingLoan: "Financing / Loan",
    map: "Map",
    intelligentLeads: "Intelligent Leads",
    startYourOwnBusiness: "Start Your Own Business",
    interestInLearning: "Interested in learning competing options",
    reduceCosts: "Reduce costs",
    quickerCash: "Quicker cash availability",
    betterTransaction: "Better transaction reporting",
    healthInsurance: "Health Insurance",
    workersCompensation: "'Worker\'s Compensation",
    equipment: "Equipment",
    expansion: "Expansion of current business",
    acquisition: "Acquisition of another business",
    ownerOccupied: "Owner-occupied real estate",
    workingCapital: "Working capital",
    otherPurpose: "Other purpose",
    own_business: "I own this business",
    selling_business: "Interested in selling this business",
    looking_loan: "Looking for a loan",
    buying_business: "Interested in buying this business",
    seeking_investment: "Seeking investment",
    starting_business: "I work at this business",
    insuring_business: "Seeking insurance",
    just_curious: "I'm just curious",
    aboutUs: "About Us",
    rs11Foundation: "RS11 Foundation",
    inviteOthers: "Invite Others",
    help: "Help",
    contactUs: "Contact Us",
    press: "Press",
    career: "Career",
    privacy: "Privacy",
    terms: "Terms",
    accountSettings: "Account Settings",
    buy: 'Buying It',
    lend: 'Lending',
    invest: 'Investing',
    sell_product: 'Selling product',
    employment: 'Employment',
    sell_service: 'Selling service',
    partial_owner: 'Partial Owner',
    other: 'Other',
    employee: 'Employee',
    customer: 'Customer',
    bank: 'Bank',
    venture_pe: 'Venture/PE',
    broker: 'Broker',
    service: 'Service',
    insurer: 'Insurer',
    govt: "Gov't",
    get_investment: 'Getting investment',
    get_loan: 'Getting a loan',
    insure_business: 'Insuring business',
    sell_business: 'Selling business',
    buy_business: 'Buying a business',
    other: 'Other',
    owner: 'Owner',
    manager: 'Manager'
}

export default Mappings;